// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Ij8V","validationTips":"StatementDescriptor_validationTips__15nk-"};